import React from 'react';
import { Container } from '@mui/material';
import RelatorioRomaneioBase from '../components/relatorios/RelatorioRomaneioBase';
import { relatorioRomaneioService } from '../services/relatorioRomaneio';

const RelatorioItensNaoVendidosRomaneio: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <RelatorioRomaneioBase
        titulo="Relatório - Romaneio Conferência (Itens Não Vendidos)"
        gerarRelatorio={relatorioRomaneioService.getItensNaoVendidosPorIdRomaneio}
        getFilename={(id) => `Romaneio_${id}_ItensDevolvidos.xlsx`}
      />
    </Container>
  );
};

export default RelatorioItensNaoVendidosRomaneio;
